
export const StripeCreateCardFooter = "stripeCreateCardFooter";

export function stripeCreateCardFooter() {
    return {
        template: "<ng-transclude></ng-transclude>",
        transclude: true
    };
}
